<template>
  <div
    class="menu"
    :class="{ active: option.active }"
    role="button"
    @click.stop="$emit('click')"
  >
    <span
      v-if="variant === 'icon' && option.icon"
      class="material-symbols-outlined text-[16px]/[16px] select-none"
      :class="option.iconColor ? option.iconColor : 'text-gray-500'"
    >
      {{ option.icon }}
    </span>
    <span
      v-if="variant === 'label' && option.color"
      class="label-pill"
      :style="{ backgroundColor: option.color }"
    />
    <span
      v-if="variant === 'image' && option.icon"
      class="flex items-center justify-center w-4 h-4"
    >
      <span
        class="icon-mask"
        :class="`icon-${option.key}`"
        :style="{
          '-webkit-mask-image': `url(${option.icon})`,
          'mask-image': `url(${option.icon})`,
        }"
        :aria-label="option.label"
      />
    </span>
    <thumbnail
      v-if="variant === 'agent'"
      :username="option.label"
      :src="option.thumbnail"
      :status="option.status"
      size="16px"
      class="agent-thumbnail"
    />
    <div
      class="menu-label"
      :class="option.labelColor ? option.labelColor : 'text-gray-600'"
    >
      {{ option.label }}
      <svg
        v-if="option.active && variant === 'label'"
        width="12"
        height="9"
        viewBox="0 0 12 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.64425 8.6885L0 5.04425L1.04425 4L3.64425 6.6L10.2443 0L11.2885 1.04425L3.64425 8.6885Z"
          fill="#1F845A"
          style="
            fill: #1f845a;
            fill: color(display-p3 0.1216 0.5176 0.3529);
            fill-opacity: 1;
          "
        />
      </svg>
    </div>
    <!-- d99d — optional info hint with tooltip -->
    <span
      v-if="option.info"
      v-tooltip.top="option.info"
      class="menu-info"
      @click.stop
    >
      <fluent-icon icon="info" size="14" />
    </span>
  </div>
</template>

<script>
import Thumbnail from 'dashboard/components/widgets/Thumbnail.vue';
export default {
  components: {
    Thumbnail,
  },
  props: {
    option: {
      type: Object,
      default: () => {},
    },
    variant: {
      type: String,
      default: 'default',
    },
  },
};
</script>

<style scoped lang="scss">
.menu {
  @apply flex items-center flex-nowrap px-2 py-1 rounded-sm overflow-hidden cursor-pointer gap-1;

  &.active,
  &:hover {
    @apply bg-green-50;

    .material-symbols-outlined {
      @apply text-[#1F845A];
    }

    .menu-label {
      @apply text-[#164B35];
    }

    .icon-mask {
      background-color: #1f845a;
    }
  }

  .menu-label {
    @apply m-0 text-sm flex-shrink-0 overflow-hidden whitespace-nowrap text-ellipsis;
    @apply flex-1 flex items-center justify-between;
  }

  // d99d — trailing info hint
  .menu-info {
    @apply ml-auto flex items-center opacity-60 flex-shrink-0;
  }
}

.agent-thumbnail {
  margin-top: 0 !important;
}

.label-pill {
  @apply w-4 h-4 rounded-full border border-slate-50 border-solid dark:border-slate-900 flex-shrink-0;
}

.icon-mask {
  background-color: #6b7280;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-position: center;
  mask-position: center;
}

.icon-pending {
  width: 14px;
  height: 15px;
}

.icon-open {
  width: 13px;
  height: 13px;
}
</style>
